import AWS from 'aws-sdk';
AWS.config.update({
    accessKeyId: process.env.REACT_APP_ACCESS_KEY_ID,
    secretAccessKey: process.env.REACT_APP_SECRET_ACCESS_KEY,
    region: process.env.REACT_APP_REGION
});

const generateGuId = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0,
            v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });

}

const checkType = (type: any) => {
    let location;
    switch (type) {
        case 1:
            location = "products/images/"
            break;
        case 2:
            location = "products/videos/"
            break;
        case 3:
            location = "category/images/"
            break;
        case 4:
            location = "sub_category/images/"
            break;
        case 5:
            location = "banner/images/"
            break;
        case 6:
            location = "procurement/images/"
            break;
        case 7:
            location = "vendor/bills/images/"
            break;
        case 8:
            location = "vendor/debt/proof/"
            break;
        case 9:
            location = "rental/receipts/"
            break;
        default:
            location = "products/images/"
            break;
    }

    return location;
}

export const getFileName = (file: any) => {
    console.log("file=====>", file)
    try {
        let fileName = '';
        let extension = file.substring(file.lastIndexOf('.'));
        let randomGuid = generateGuId();
        fileName = randomGuid + extension;
        return fileName;
    } catch (ex) {
        console.log("Error in getFileName::" + ex);
    }
}
let allFiles: any = [];

// const inserFileIds = (callBack: any, file: any, filesSize: any) => {
const inserFileIds = (callBack: any, file: any, type: number) => {
    // allFiles.push(file);
    // console.log('allFiles', allFiles.length, filesSize)
    console.log('allFiles', allFiles.length)
    // if (allFiles.length == filesSize) {
    // callBack(allFiles);
    callBack(file, 0, 0, type);
    // allFiles = [];
    // }
}

// export const uploadFiles = (file: any, filesSize: any, callBack: any) => {
export const uploadFiles = (file: any, callBack: any, type: number) => {
    console.log("file==>", file);
    // console.log("filesSize==>",filesSize);
    try {
        let s3 = new AWS.S3({ params: { Bucket: process.env.REACT_APP_IMAGE_BUCKET } });
        let fileName: any = getFileName(file?.file?.name);
        // let location;
        // switch (type) {
        //     case 1:
        //         location = "products/images/"
        //         break;
        //     case 2:
        //         location = "products/videos/"
        //         break;
        //     case 3:
        //         location = "category/images/"
        //         break;
        //     case 4:
        //         location = "sub_category/images/"
        //         break;
        //     case 5:
        //         location = "banner/images/"
        //         break;
        //     default:
        //         location = "products/images/"
        //         break;
        // }

        let location = checkType(type);

        const params: any = {
            ACL: 'bucket-owner-full-control',
            Key: process.env.REACT_APP_IMAGE_DESTINATION_BUCKET + location + fileName,
            ContentType: file?.file?.type,
            Body: file?.file,
        }
        s3.putObject(params).on('httpUploadProgress', (evt: any) => {
            let progressPercent = Math.round((evt.loaded / evt.total) * 100);
            if (progressPercent <= 90) {
                //    props.setPhotoProgress(progressPercent)
            }
        }).send((err: any) => {
            if (err) {
                console.log("************Error", err);
            } else {
                file['fileUuid'] = fileName
                // inserFileIds(callBack, file, filesSize);
                inserFileIds(callBack, file, type);
            }
        });
    } catch (ex) {
        console.log("Error in uploadFiles::" + ex);
    }
}

// export function uploadPhotoToAWS(fileArray: any, callBack: any): any {
export function uploadPhotoToAWS(file: any, callBack: any, type: number): any {
    try {
        // console.log("fileArray", fileArray)
        console.log("file", file)
        // for (let file of fileArray) {
        // uploadFiles(file, fileArray.length, callBack);
        uploadFiles(file, callBack, type);
        // }
    } catch (error) {
        console.log("Error in uploadPhotoToAWS", error)
    }

}

export const deleteFileFromS3 = (key: any, type: number) => {
    // const params = {
    //   Bucket: process.env.REACT_APP_IMAGE_BUCKET, // Replace with your bucket name
    //   Key: key // The key (path) of the object you want to delete
    // };
    let location = checkType(type);
    // let location = type == 1 ? "products/images/" : "products/videos/"
    console.log("location===>", location)
    let s3 = new AWS.S3({ params: { Bucket: process.env.REACT_APP_IMAGE_BUCKET, Key: process.env.REACT_APP_IMAGE_DESTINATION_BUCKET + location + key } });
    s3.deleteObject((err: any, data: any) => {
        if (err) {
            console.log('Error deleting file:', err);
        } else {
            console.log('Successfully deleted file from S3', data);
            // Handle success, e.g., update state or notify user
        }
    });
};

